import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

const categorySelectionPageUrl = '/categories/';
const brandSelectionPageUrl = '/brands/';

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  categorySelectionPages: [
    { pathname: categorySelectionPageUrl, field: 'category' },
    { pathname: brandSelectionPageUrl, field: 'brand_name' },
  ],
  fitmentSearch: {
    ...bigcommerceGenericDefaults.fitmentSearch,
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'FacetVehicleWidget',
          'VehicleWidgetDialog',
          'HomeVehicleWidget',
          'Garage',
          'MobileGarage',
          'CategoryPage',
          'SearchBoxDialogButton',
        ].includes(w.name),
    ),
    {
      name: 'FacetVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '.heroCarousel',
        class: 'cm_vehicle-widget__home_container homepage-section',
        wrapper: 'section',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'Garage',
      location: {
        selector: '#cm-garage',
        class: 'cm_garage__desktop header__icon',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: { selector: '#cm-mobile-garage', class: 'cm_garage__mobile' },
      template: 'fitmentSearch/mobileGarage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { selector: '.body .page', class: 'wrapper' },
      template: 'SearchPage',
      visibleIf: () =>
        window.document.querySelector(
          '[data-content-region=category_below_header], [data-content-region=brand_below_header]',
        ) &&
        window.location.pathname !== categorySelectionPageUrl &&
        window.location.pathname !== brandSelectionPageUrl,
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        firstChildOf: '.off-canvas-list.off-canvas-list-menu',
        class: 'cm-mobile-search-box',
        wrapper: 'li',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
  ],
};
